export const AI_PROMPT_KINDS = Object.freeze([
  'job_generate',
  'job_shorten',
  'proposal_refine',
  'proposal_shorten',
  'proposal_items',
]);

export const PLATFORM_TEMPLATE_VALUE = 'platform';

export const AI_PROMPT_KIND_LABELS = Object.freeze({
  job_generate: 'Job write',
  job_shorten: 'Job shorten',
  proposal_refine: 'Proposal write',
  proposal_shorten: 'Proposal shorten',
  proposal_items: 'Line items',
});

export const getAiPromptKindLabel = (kind) => AI_PROMPT_KIND_LABELS[kind] || kind;

/**
 * Build generate-request fields from the selected template value for a kind.
 * @param {string|null|undefined} selectedValue - template uuid | 'platform' | null/undefined
 * @param {'default'|'text'|'items'} [side='default']
 * @returns {Record<string, string|boolean>}
 */
export const buildPromptSelectionPayload = (selectedValue, side = 'default') => {
  // No selection yet → omit fields so the server can use the company default.
  if (selectedValue === undefined || selectedValue === null || selectedValue === '') {
    return {};
  }
  const wantsPlatform = selectedValue === PLATFORM_TEMPLATE_VALUE;
  if (side === 'text') {
    if (wantsPlatform) return { use_platform_text_prompts: true };
    return { text_prompt_template_id: selectedValue };
  }
  if (side === 'items') {
    if (wantsPlatform) return { use_platform_items_prompts: true };
    return { items_prompt_template_id: selectedValue };
  }
  if (wantsPlatform) return { use_platform_prompts: true };
  return { prompt_template_id: selectedValue };
};

/**
 * Pick the initial select value for a kind: company default if set, else platform.
 * @param {Array<{ id: string, kind: string, is_default?: boolean }>} templates
 * @param {string} kind
 * @returns {string}
 */
export const getInitialTemplateSelection = (templates, kind) => {
  const list = Array.isArray(templates) ? templates.filter((t) => t.kind === kind) : [];
  const defaultTemplate = list.find((t) => t.is_default);
  return defaultTemplate?.id || PLATFORM_TEMPLATE_VALUE;
};
